<template>
  <view-container>
    <list-header
      :add="
        user.isAdmin && {
          name: 'group-new'
        }
      "
    />
    <v-card>
      <v-list>
        <template v-for="(item, index) in items">
          <v-divider :key="index" v-if="index > 0" />
          <v-list-item :key="item.id">
            <v-list-item-content>
              <v-list-item-title v-text="item.name" />
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <data-loader :load="load" v-model="items" />
    </v-card>
  </view-container>
</template>
<script>
import ds from "@/datastore";
export default {
  name: "GroupList",
  props: {
    id: String
  },
  data() {
    return {
      items: []
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    clientId() {
      return this.user.clientId || this.id;
    }
  },
  methods: {
    async load(pager) {
      return await ds.findAll("group", { ...pager, clientId: this.clientId });
    }
  },
  created() {
    ds.on("afterCreate", (mapperName, props, opts, result) => {
      mapperName === "group" && this.items.unshift(result);
    });
    ds.on("afterDestroy", (mapperName, id) => {
      mapperName === "group" &&
        (this.items = this.items.filter(item => item.id != id));
    });
  }
};
</script>
